"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("@pbl/pbl-react-core/lib/models/draws/types");
var action_type_util_1 = require("../../action-type.util");
var INITIAL_STATE = {
    promotions: [],
    promotionPage: {},
    featuredPromotion: {},
    selectedPromotion: {},
    loading: false,
    errorMessage: null,
    giveawayErrorMessage: null,
    draws: [],
    homePromotions: [],
    giveawayDraws: [],
    hasGiveawayEntry: false
};
exports.default = (function (state, action) {
    if (state === void 0) { state = INITIAL_STATE; }
    switch (action.type) {
        case (0, action_type_util_1.REQUEST)(types_1.FETCH_PROMOTIONS):
        case (0, action_type_util_1.REQUEST)(types_1.FETCH_PROMOTION_DETAILS):
        case (0, action_type_util_1.REQUEST)(types_1.FETCH_DRAWS_BY_PROMOTION):
        case (0, action_type_util_1.REQUEST)(types_1.FETCH_DRAWS_BY_GIVEAWAY_PROMOTION):
        case (0, action_type_util_1.REQUEST)(types_1.POST_GIVEAWAY_PROMOTION_ENTRIES):
        case (0, action_type_util_1.REQUEST)(types_1.GET_GIVEAWAY_PROMOTION_ENTRIES):
            return __assign(__assign({}, state), { loading: true });
        case (0, action_type_util_1.SUCCESS)(types_1.GET_GIVEAWAY_PROMOTION_ENTRIES):
            return __assign(__assign({}, state), { hasGiveawayEntry: action.payload });
        case (0, action_type_util_1.SUCCESS)(types_1.FETCH_PROGRESSIVE_PRIZES):
            return __assign(__assign({}, state), { promotions: action.payload.promotions, featuredPromotion: action.payload.featuredPromotion });
        case (0, action_type_util_1.SUCCESS)(types_1.FETCH_PROMOTIONS):
            return __assign(__assign({}, state), { loading: false, featuredPromotion: action.payload.content && action.payload.content.length > 0
                    ? action.payload.content[0]
                    : {}, promotionPage: action.payload.page });
        case (0, action_type_util_1.SUCCESS)(types_1.FETCH_PROMOTIONS_WITHOUT_FEATURED):
            return __assign(__assign({}, state), { loading: false, promotions: action.payload.content && action.payload.content.length > 0 ? action.payload.content : [], promotionPage: action.payload.page });
        case (0, action_type_util_1.SUCCESS)(types_1.FETCH_PROMOTION_DETAILS):
            return __assign(__assign({}, state), { loading: false, selectedPromotion: action.payload });
        case types_1.RESET_PROMOTION:
            return __assign(__assign({}, state), { selectedPromotion: {} });
        case (0, action_type_util_1.SUCCESS)(types_1.FETCH_DRAWS_BY_PROMOTION):
            return __assign(__assign({}, state), { loading: false, draws: action.payload });
        case (0, action_type_util_1.SUCCESS)(types_1.FETCH_DRAWS_BY_GIVEAWAY_PROMOTION):
            return __assign(__assign({}, state), { loading: false, giveawayDraws: action.payload.content });
        case (0, action_type_util_1.SUCCESS)(types_1.LOAD_MORE): {
            return __assign(__assign({}, state), { promotions: action.payload.content, promotionPage: action.payload.page });
        }
        case (0, action_type_util_1.SUCCESS)(types_1.FETCH_DRAWS): {
            return __assign(__assign({}, state), { homePromotions: action.payload.content });
        }
        case (0, action_type_util_1.SUCCESS)(types_1.FETCH_DETAILS_PAGE_PROGRESSIVE_PRIZES):
            return __assign(__assign({}, state), { selectedPromotion: __assign({}, action.payload) });
        case types_1.SELECT_PROMOTION: {
            return __assign(__assign({}, state), { selectedPromotion: action.payload });
        }
        case (0, action_type_util_1.FAILURE)(types_1.FETCH_PROMOTIONS):
        case (0, action_type_util_1.FAILURE)(types_1.FETCH_PROMOTION_DETAILS):
        case (0, action_type_util_1.FAILURE)(types_1.FETCH_DRAWS_BY_PROMOTION):
        case (0, action_type_util_1.FAILURE)(types_1.FETCH_DRAWS_BY_GIVEAWAY_PROMOTION):
        case (0, action_type_util_1.FAILURE)(types_1.FETCH_DRAWS):
            return __assign(__assign({}, state), { loading: false, errorMessage: action.payload });
        case (0, action_type_util_1.FAILURE)(types_1.GET_GIVEAWAY_PROMOTION_ENTRIES):
            return __assign(__assign({}, state), { loading: false, giveawayErrorMessage: action.payload.message });
        case (0, action_type_util_1.FAILURE)(types_1.POST_GIVEAWAY_PROMOTION_ENTRIES):
            return __assign(__assign({}, state), { loading: false, giveawayErrorMessage: action.payload.message });
        default:
            return state;
    }
});
//# sourceMappingURL=reducers.js.map